import { Paper, Grid, Button, Typography, Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Box } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import StandardPage from '~/layouts/StandardPage';

import UserProfile from '~/containers/UserProfile';
import DeleteAccountModal from '~/components/DeleteAccountModal';
import { useSelector } from 'react-redux';
import { RootState, UserState } from '~/types';
import { useNavigate } from 'react-router-dom';

function UserProfileRoute() {
  const [showDelete, setShowDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const userState = useSelector<RootState, UserState | null>(({ user }) => user);

  useEffect(() => {
    if (!userState?.isAuthenticated) {
      navigate('/login', { state: { from: 'manage' } });
    }
  }, [userState]);

  const handleToggleDelete = () => {
    setShowDelete((prev) => !prev);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  }

  const handleOpenModal = () => {
    setShowModal(true);
  }

  const content = (
    <Box ml={2} mr={2}>
      <Grid container spacing={2}>
        {/* Left side: User Profile */}
        <Grid item xs={12} md={9}>
          <Paper
            elevation={3}
            style={{ padding: '15px', borderRadius: 20 }}
          >
            <UserProfile />
          </Paper>
        </Grid>

        {/* Right side: Accordion-like delete section */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            style={{ padding: '15px', borderRadius: 20 }}
          >
            <List>
              <ListItem onClick={handleToggleDelete}>
                <ListItemIcon>
                  <DeleteIcon style={{ color: '#1976d2' }} />
                </ListItemIcon>
                <ListItemText primary="Delete my account" style={{ color: '#1976d2', cursor: 'pointer' }} />
              </ListItem>
            </List>
            <Collapse in={showDelete} sx={{ textAlign: 'right' }}>
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleOpenModal}
                >
                  Delete Account
                </Button>
              </Box>
            </Collapse>
          </Paper>
          <DeleteAccountModal
            open={showModal}
            onClose={handleCloseModal}
          />
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <StandardPage
      bannerContent={
        <Typography variant="h4" component="h1" gutterBottom color={'white'}>
          My Account
        </Typography>
      }
    >
      {content}
    </StandardPage>
  );
}

export default UserProfileRoute;